<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div>
        </div>
        <a-button v-has="'ORGANIZATION_ADD'" type="primary" @click="addOrganization">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        style="width: 100%"
        default-expand-all-rows
        row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        :data-source="table.data">
        <a-table-column
          data-index="name"
          title="组织名称"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="createUser"
          title="创建人"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="createAt"
          title="创建时间"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="updateUser"
          title="更新人"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="updateAt"
          title="更新时间"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION') || '操作'">
          <template slot-scope="text, record">
            <a-button
              type="link"
              v-has="'ORGANIZATION_EDIT'"
              @click="editOrganization(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button
              type="link"
              v-has="'ORGANIZATION_DELETE'"
              @click="deleteOrganization(record.id)">{{ $t('DELETE') || '删除' }}
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
:footer="null"
      title="提示"
      @close="closeForm"
      v-model="form.visible">
      <organization-edit
        v-if="form.visible"
        :organization-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </organization-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _deleteOrganization,
  _queryOrganizations,
} from '@/api/sysOrganizationApi';
import OrganizationEdit from './OrganizationEdit.vue';
import { _downArticle } from '@/api/articleApi';

function treeGenerator(x, data) {
  const children = data
    .filter(child => child.parentId === x.id)
    .map(child => treeGenerator(child, data));
  return {
    ...x,
    children,
  };
}

async function getOrganizationList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const { content } = await _queryOrganizations({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
    date: this.table.query.date,
  });
  this.table.data = content
    .filter(x => !x.parentId)
    .map(x => treeGenerator(x, content));
}

function addOrganization() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editOrganization(organizationId) {
  this.form.data.id = organizationId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getOrganizationList();
}

async function deleteOrganization(organizationId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      const result = await _deleteOrganization(organizationId);
      if (result) {
        this.$message.success('删除成功');
        await this.getOrganizationList();
      }
    },
  });
}

export default {
  name: 'OrganizationList',
  components: { OrganizationEdit },
  data() {
    return {
      formInline: {
        user: '',
        region: '',
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'name',
          order: 'ascend',
        },
      },
    };
  },
  methods: {
    getOrganizationList,
    deleteOrganization,
    editOrganization,
    addOrganization,
    closeForm,
  },
  created() {
    this.getOrganizationList();
  },
};
</script>

<style scoped>

</style>
